import { useCallback, useState } from 'react';

import { useNewUserAccessRights } from '@app/hooks/useNewUserAccessRights';

export const useLoyaltyChatSettingsLauncher = () => {
  const [integrationId, setIntegrationId] = useState<number | null>(null);
  const {
    userAccessRights: { Integrations },
  } = useNewUserAccessRights();
  const canEdit = Integrations.IsOn && Integrations.IsEdit;

  const openSettingsHandler = useCallback(
    (id: number) => {
      if (canEdit && Number.isInteger(id) && id > 0) setIntegrationId(id);
    },
    [canEdit]
  );
  const closeSettingsHandler = useCallback(() => setIntegrationId(null), []);

  return { integrationId, canEdit, openSettingsHandler, closeSettingsHandler };
};
